import { render, staticRenderFns } from "./QuotationProducts.vue?vue&type=template&id=5154f730&scoped=true&"
import script from "./QuotationProducts.vue?vue&type=script&lang=js&"
export * from "./QuotationProducts.vue?vue&type=script&lang=js&"
import style0 from "./QuotationProducts.vue?vue&type=style&index=0&id=5154f730&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5154f730",
  null
  
)

export default component.exports